import React, { useEffect, useState } from 'react'
import plus from '../dist/webImages/plus.png'
import SkeletonHeading from '../components/SkeletonHeading';
import UserCard from './UserCard';
import { Link } from 'react-router-dom';
import SkeletonUserCard from './SkeletonUserCard';
import useFetch from '../customHooks/useFetch';

const User = () => {
    const { loading, data } = useFetch(`allUsers`)
    const [datas, setDatas] = useState()

    useEffect(() => {
        if (data) {
            setDatas(data?.data);
        }
    }, [data]);

    return (
        <div className='TeamPage'>
            {/* <div className="TeamPageTop mb-2 flex justify-between items-center">
                {loading ? <SkeletonHeading /> : <h6 className='text-[1.5rem] mb-2 bookingSectionh relative px-3 font-Mluvka'>Users</h6>}
                <div className="text-secondary font-semibold text-[1.1rem]"><span><Link to={`/`}>Home</Link></span> / <span><Link to={`/users`}>Users</Link></span></div>
            </div> */}
            <Link to={"/users/create"} className='bg-[#A38560]/50 py-2 px-4 w-fit ml-auto rounded-full flex items-center gap-2 cursor-pointer'>
                <img src={plus} alt="plus" className="w-6" />
                <span className='font-MluvkaBold text-secondary text-[.9rem] capitalize'>Add new</span>
            </Link>
            <div className="TeamPageGrid mt-4 rounded-3xl grid grid-cols-5 gap-3 max-lg:grid-cols-1">
                {loading ?
                    Array.from({ length: 8 }).map((_, index) => (
                        <React.Fragment key={index}>
                            <SkeletonUserCard />
                        </React.Fragment>
                    ))
                    :
                    Array.isArray(datas) && datas.map((item, index) => {
                        return (
                            <React.Fragment key={index}>
                                <UserCard data={item} alldata={datas} deleted={setDatas} />
                            </React.Fragment>
                        )
                    })}
            </div>
        </div>
    )
}

export default User
